class Countdown extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.buyBtn = document.querySelector("[data-block-type='buy-buttons']");
    this.container = this.querySelector(".countdown_container");
    this.hourEl = this.querySelector(
      ".countdown_sale-countdown-timer__hours-number"
    );
    this.minuteEl = this.querySelector(
      ".countdown_sale-countdown-timer__minutes-number"
    );
    this.secondEl = this.querySelector(
      ".countdown_sale-countdown-timer__seconds-number"
    );

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  getCurrentTime() {
    return new Date().getTime();
  }

  getEndDate() {
    return new Date(window.mb?.countdown?.endDate).getTime();
  }

  calculateTime(milliseconds) {
    let hours = Math.floor(milliseconds / (60 * 60 * 1000));
    milliseconds -= hours * 60 * 60 * 1000;
    let minutes = Math.floor(milliseconds / (60 * 1000));
    milliseconds -= minutes * 60 * 1000;
    let seconds = Math.floor(milliseconds / 1000);

    return {
      hours: hours < 10 ? `0${hours}` : `${hours}`,
      minutes: minutes < 10 ? `0${minutes}` : `${minutes}`,
      seconds: seconds < 10 ? `0${seconds}` : `${seconds}`,
    };
  }

  hideCountdown() {
    if (this.container) {
      this.container.classList.add("hidden");
    }
    if (this.hourEl) this.hourEl.innerText = "00";
    if (this.minuteEl) this.minuteEl.innerText = "00";
    if (this.secondEl) this.secondEl.innerText = "00";
  }

  showCountdown() {
    this.container?.classList.remove("hidden");
  }

  hideBuyButton() {
    this.buyBtn.classList.add("hidden");
  }

  showBuyButton() {
    this.buyBtn.classList.remove("hidden");
  }

  updateCountdown() {
    const now = this.getCurrentTime();
    const remaining = this.getEndDate() - now;

    if (remaining <= 0) {
      this.hideCountdown();
      this.showBuyButton();
      clearInterval(this.interval);
    } else {
      this.showCountdown();
      this.hideBuyButton();
      const time = this.calculateTime(remaining);
      this.hourEl.innerText = time.hours;
      this.minuteEl.innerText = time.minutes;
      this.secondEl.innerText = time.seconds;
    }
  }
}

customElements.define("product-countdown", Countdown);

class MrCartUpsell extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const btn = this.querySelector('.mr-cart-upsell_atc_btn');
    if (btn) {
      btn.addEventListener('click', this.addToCart.bind(this));
    }
  }

  disconnectedCallback() {
    const btn = this.querySelector('.mr-cart-upsell_atc_btn');
    if (btn) {
      btn.removeEventListener('click', this.addToCart.bind(this));
    }
  }

  async addToCart(event) {
    event.preventDefault();
    const variantId = this.dataset.varId;

    if (!variantId) {
      console.error('No variant ID found on mr-cart-upsell element');
      return;
    }

    try {
      await Cart.addItems({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(variantId, 10),
              quantity: 1,
            },
          ],
          sections: Cart.sections, // sorgt dafür, dass deine Sections (Drawer, Desktop etc.) neu gerendert werden
        }),
      });

      // Optional: Drawer öffnen, wenn du sicherstellen willst, dass er aufgeht
      window.trigger('theme:cart:updated');
    } catch (err) {
      console.error('Error adding upsell item to cart:', err);
    }
  }
}

customElements.define('mr-cart-upsell', MrCartUpsell);

class MrPDPUpsell extends HTMLElement {
  constructor() {
    super();
    this.addToCartHandler = this.addToCart.bind(this);
  }

  connectedCallback() {
    const btns = this.querySelectorAll('.mr-upsell_atc_btn');
    btns.forEach(btn => {
      btn.addEventListener('click', this.addToCartHandler);
    });
  }

  disconnectedCallback() {
    const btns = this.querySelectorAll('.mr-upsell_atc_btn');
    btns.forEach(btn => {
      btn.removeEventListener('click', this.addToCartHandler);
    });
  }

  async addToCart(event) {
    event.preventDefault();

    const el = event.target.closest(".mr-upsell_el");
    const variantId = el?.dataset.varId;

    if (!variantId) {
      console.error("No variant ID found on upsell element");
      return;
    }

    const btn = el.querySelector(".mr-upsell_atc_btn");
    const plusIcon = btn.querySelector("svg");
    const spinner = btn.querySelector(".product-buy-buttons--spinner");

    try {
      // Plus ausblenden & Spinner einblenden
      plusIcon?.classList.add("hidden");
      spinner?.classList.remove("hidden");
      btn.style.pointerEvents = "none";
      btn.style.opacity = "0.6";

      await Cart.addItems({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(variantId, 10),
              quantity: 1,
            },
          ],
          sections: Cart.sections,
        }),
      });

      // Drawer öffnen
      console.log(window.Drawer);
      if (window.Drawer) {
        Drawer.open("right", "cart-drawer", this);
        console.log('test00');
      } else {
        window.trigger?.("theme:cart:updated");
      }

    } catch (err) {
      console.error("Error adding upsell item to cart:", err);
    } finally {
      // Plus wieder anzeigen & Spinner ausblenden
      plusIcon?.classList.remove("hidden");
      spinner?.classList.add("hidden");
      btn.style.pointerEvents = "";
      btn.style.opacity = "";
    }
  }
}

customElements.define('mr-pdp-upsell', MrPDPUpsell);


class MrPdpDiscountCode extends HTMLElement {
  constructor() {
    super();
    this.codeSpan = this.querySelector('.discount_code_js');
    this.trigger = this.querySelector('.discount-code_copy_trigger');
    this.copyConfirm = this.querySelector('.discount-code_copy_copy');
    this.container = this;
  }

  connectedCallback() {
    const end = window.mb?.countdown_discount?.endDate;

    if (end instanceof Date && !isNaN(end)) {
      const now = new Date();

      if (end < now) {
        this.classList.add('hidden');
        return;
      }
    }
    const urlParams = new URLSearchParams(window.location.search);
    const urlCode = urlParams.get('code');
    const fallbackCode = this.dataset.defaultCode;
    const finalCode = urlCode || fallbackCode;

    if ((!urlCode && !fallbackCode) || !this.codeSpan || !this.trigger || !this.copyConfirm) {
      return;
    }

    this.showCode(finalCode);
    this.enableCopy(finalCode);
    this.appendCodeToSwatches(finalCode);
  }

  showCode(code) {
    this.codeSpan.textContent = code;
    this.container.classList.remove('hidden');
  }

  enableCopy(code) {
    this.trigger.addEventListener('click', () => {
      navigator.clipboard.writeText(code).then(() => {
        this.trigger.classList.add('hidden');
        this.copyConfirm.classList.remove('hidden');
        setTimeout(() => {
          this.trigger.classList.remove('hidden');
          this.copyConfirm.classList.add('hidden');
        }, 3000);
      });
    });
  }

  appendCodeToSwatches(code) {
    const labels = document.querySelectorAll('.product__info-wrapper .new-color-swatch-wrapper[onclick]');

    labels.forEach((label) => {
      const original = label.getAttribute('onclick');
      if (!original || !original.includes('window.location.href')) return;

      const match = original.match(/window\.location\.href\s*=\s*['"]([^'"]+)['"]/);
      if (!match) return;

      const url = new URL(match[1], window.location.origin);

      if (!url.searchParams.has('code')) {
        url.searchParams.set('code', code);
      }

      label.setAttribute('onclick', `window.location.href='${url.pathname}${url.search}'`);
    });
  }
}

customElements.define('mr-pdp-discount', MrPdpDiscountCode);
// PDP Mobile: Pfeile/Swipe im Hauptbild klicken das vorige/naechste Thumbnail (Theme-Logik fuer Wechsel bleibt)
const mrStepMedia = (variants, step) => {
  const thumbs = [...variants.querySelectorAll('.product-media--thumb')];
  if (thumbs.length < 2) return;
  const active = thumbs.findIndex((thumb) => thumb.dataset.active === 'true');
  const next = thumbs[(active + step + thumbs.length) % thumbs.length];
  next.click();
  next.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
};

document.addEventListener('click', (event) => {
  const arrow = event.target.closest('[data-mr-media-arrow]');
  if (arrow) mrStepMedia(arrow.closest('product-media-variants'), Number(arrow.dataset.mrMediaArrow));
});

// Swipe im Hauptbild (mobil) und im Bild-Modal; nur ein Finger und nicht pinch-gezoomt
let mrSwipe = null;
document.addEventListener('touchstart', (event) => {
  const target = event.target.closest('.main-product--mobile .product-media--variants, modal-element[data-id$="_main-product"]');
  const zoomed = (window.visualViewport?.scale ?? 1) > 1.01;
  mrSwipe = target && event.touches.length === 1 && !zoomed
    ? { target, x: event.touches[0].clientX, y: event.touches[0].clientY }
    : null;
}, { passive: true });

document.addEventListener('touchend', (event) => {
  if (!mrSwipe) return;
  const { target, x, y } = mrSwipe;
  mrSwipe = null;
  const dx = event.changedTouches[0].clientX - x;
  const dy = event.changedTouches[0].clientY - y;
  if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
  const step = dx < 0 ? 1 : -1;
  if (target.matches('modal-element')) {
    document.querySelector(step > 0 ? '.layout--next' : '.layout--previous')?.click();
  } else {
    mrStepMedia(target.closest('product-media-variants'), step);
  }
});
